import TableRow from '@material-ui/core/TableRow';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import ActionsCell from './ActionsCell';
import Cell from './Cell';
import useStyles from './Row.styles';
import { TableRowActionExact } from '../../models/tableRowAction';

const Row = ({ row, onRowClick, rowActions, hoverEnabled, style }) => {
  const classes = useStyles();

  const [isHovered, setIsHovered] = useState(false);

  const handleClick = useCallback(() => {
    if (onRowClick) onRowClick(row.original, row.id);
  }, [onRowClick, row.original, row.id]);

  const handleMouseEnter = useCallback(() => {
    if (hoverEnabled) setIsHovered(true);
  }, [hoverEnabled]);

  const handleMouseLeave = useCallback(() => {
    if (hoverEnabled) setIsHovered(false);
  }, [hoverEnabled]);

  return (
    <TableRow
      id={row.id}
      classes={classes}
      hover={hoverEnabled}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={style}>
      {row.cells.map((cell) => {
        const { key, role } = cell.getCellProps();
        return <Cell key={key} role={role} cell={cell} />;
      })}

      {rowActions && !!rowActions.length && <ActionsCell actions={rowActions} rowValue={row.original} visible={isHovered} />}
    </TableRow>
  );
};

Row.propTypes = {
  hoverEnabled: PropTypes.bool,
  onRowClick: PropTypes.func,
  row: PropTypes.shape().isRequired,
  rowActions: PropTypes.arrayOf(TableRowActionExact),
  style: PropTypes.shape(),
};

Row.defaultProps = {
  hoverEnabled: false,
  onRowClick: undefined,
  rowActions: [],
  style: undefined,
};

export default Row;
